import { render, staticRenderFns } from "./BowRing.vue?vue&type=template&id=e4e7a5b8&"
import script from "./BowRing.vue?vue&type=script&lang=js&"
export * from "./BowRing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports